export const alertStatusColors = {
  todo: 'red',
  in_progress: 'blue',
  inprogress: 'blue',
  done: 'green',
};
